import { Component, Input } from '@angular/core';
import { CreditCardType } from '../../enums/creditCardType.enum';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-credit-card-type',
  standalone: true,
  imports: [
	CommonModule
  ],
  templateUrl: './credit-card-type.component.html',
  styleUrl: './credit-card-type.component.scss'
})
export class CreditCardTypeComponent {

	@Input() type: CreditCardType;
	@Input() height: number = 42;
	@Input() width: number = 62;

	creditCardToImage: { [creditCard in CreditCardType]: string } = {
		0: 'assets/credit-cards/visa.svg',
		1: 'assets/credit-cards/mastercard.svg',
		2: 'assets/credit-cards/amex.svg',
		3: 'assets/credit-cards/discover.svg'
	}

}
